import { Segment } from '../presentation-config-aggregate-types/presentation-config-aggregate-types';
import { makeAutoObservable } from 'mobx';
import TrackEntity from '../track-entity/track-entity';
import CuePointEntity from '../cue-point-entity/cue-point-entity';

class SegmentEntity {
  private tracks: TrackEntity[];

  constructor (fromDTO: Segment = {} as Segment) {
    makeAutoObservable(this);
    this.deserialize(fromDTO);
  }

  public getTracks = (): TrackEntity[] => {
    return this.tracks;
  };

  public getWorkingTracks = (): TrackEntity => {
    return this.tracks[0];
  };

  public getCuePoints = (): CuePointEntity[][] => {
    return this.tracks.map(x => x.getCuePoints());
  };

  private deserialize = (fromDTO: Segment): void => {
    this.tracks = fromDTO.tracks && fromDTO.tracks.track ?
      fromDTO.tracks.track.map(x => new TrackEntity(x))
      : [new TrackEntity()];
  };
}

export default SegmentEntity;
